
import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  /* PAGE LOAD PAR USER RESTORE */
  useEffect(() => {
    const token = localStorage.getItem("token");
    const name = localStorage.getItem("name");
    const email = localStorage.getItem("userEmail");

    if (token) {
      setUser({
        token: token,
        name: name,
        email: email,
      });
    }
  }, []);

  /* LOGIN */
  const login = (token, name, email) => {
    localStorage.setItem("token", token);
    localStorage.setItem("name", name);
    localStorage.setItem("userEmail", email);

    setUser({
      token: token,
      name: name,
      email: email,
    });
  };

  /* LOGOUT */
  const logout = () => {
    localStorage.removeItem("token")
    localStorage.removeItem("name")
    localStorage.removeItem("userEmail")

    setUser(null) // 🔥 MOST IMPORTANT

    window.location.href = "/"
  }
  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
